var chain_cat_id = "N/A";
var chain_cat_sel = "N/A";
var chain_opt_sel = "N/A";
var chain_sopt_sel = "N/A";
var clip_cat_ID = "N/A";
if (!window.console) {
    console = {
        log: function () {}
    }
}

$(document).ready( function($){

	txt1_length = 0,
	txt2_length = 0;
	var all_length =0;
	var txt1, txt2;
	var id1; var id2;
	/*var validator = $(".form").validate({
		ignore: ""
	});*/
	
	if ( $("[ajd_type='metal']").length ) {
		size_update();
	}
  var init;
  /*$(document).on('keypress','hulkapps_option_child' ,function(){    
       init =  $("input[name='properties[Top Text 1]']").next('input').val();
    console.log(init);
  });*/
 
	// TOPTEXT
	$(document).on('keyup','.frontRField',function(){ 
       var init =  $("input[name='properties[Top Text 1]']").next('input').val();
      console.log(init + 'sabi');
      if(init == undefined){
        var init =  $("input[name='properties[School Name 1]']").next('input').val();
      }
      console.log(init);
       //var init =  $("input[name='properties[Top Text 1]']").next('input').val();
	    txt1_length  = $('.f-T1').val().length;
	    txt2_length = $('.f-T2').val().length;
        id2 = $('.f-T2').attr('id');
        id1 = $('.f-T1').attr('id');
       all_length = txt1_length + txt2_length;

	    remain = parseInt(init - all_length);
	    txt1 = parseInt(init - txt2_length);
	    txt2 = parseInt(init - txt1_length);

	    $('#char_count_'+id1).text('Limit '+txt1+' Characters.');
        $('#char_count_'+id2).text('Limit '+txt2+' Characters.');
	    $('p.1').text(init+"-"+all_length+"="+remain);
	    
	     $(".f-T1").attr('maxlength',txt1);
	     $(".f-T2").attr('maxlength',txt2);
	});
		
		var urlpost = site_url + "custom/configurator/img/?";
		urlpost = urlpost + "pid=" + productid+'&template='+prod_template;
		urlpost = urlpost + "&GM=" + gmode;
		urlpost = urlpost + "&SZ=P&MP=PF";

	// Add to Cart Button
	$(".WishListbtn").on('click', function(){
		
		if ($("#AJD_form").valid()){
			//Your ajax to post the form
			wishlist_post();
		}
		else{
			// scroll to invalid field
			goToByScroll();
		}
		
		return false;
		
	});

	// Add to Cart Button
	$("#designerFormSubmit").on('click', function(){
	console.log("designerFormSubmit button clicked");
 
		if ($("#AJD_from").valid()){
			if ($("#btn-title2").length) {
				$("#btn-title2").hide();
				$("#cartbutton-load").show();
			}
			
			if($('#cart-image-holder').length) {
				submit_form();
			} else {
				func_post();			
				setTimeout(function () {
				$('#designerFormSubmit').text('Add To Cart');
				},3500);
			}
		}
		else{
			// scroll to invalid field
			goToByScroll();
		}
		

		return false;
		
	});

});

function goToByScroll(){
      // Scroll

    $('html,body').animate({
        scrollTop: $("#AJD_from").find(":input.mage-error:first").offset().top},
        'slow');

    $("#AJD_from").find(":input.mage-error:first").focus();
}

function submit_form() {

	var imghost = (("https:" == document.location.protocol) ? "https://" : "http://");
				
	var lin = imghost + 'configurator.personalizedplace.com/configurator/img/?';
	//var lin = site_url + "custom/configurator/img/?";
    lin = lin + "pid=" + productid+'&template='+prod_template;
    lin = lin + "&GM=" + gmode;
	lin = lin + '&'+(new Date()).getTime();
        if (!getCookie('frontend')){
		lin = lin + '&sessid='+ md5(FrontendForSafari);	
	}else{
		lin = lin + '&sessid='+ md5(getCookie('frontend'));
	}
	//lin = lin + '&sessid='+ md5(getCookie('frontend'));
    lin = lin + "&SZ=P&MP=PF";
    $.ajax({
        url: lin,
        type: "GET",
        success: function (data, textStatus, jqXHR) {
            if (data) {
		//console.log(data);
                func_post(data);
            }
        },
        statusCode: {
            404: function () {
                alert("Server 404 - AJAX")
            }
        }
    })

}

function migrate_data(genimage){

	var $inputs = $("form#AJD_from :input");
	 $inputs.each(function () {
		   console.log($(this).attr("type"));
		 if ($(this).attr("type") == "text2" || $('#text-6686').val() || $(this).attr("ajd_type") == "text2") {
                       $('#options_6686_text').val($('#text-6686').val());
                       $('input[name="options[' +$(this).attr("ajd_optid")+ ']"]').val($(this).val());
                       $('#options_'+$(this).attr("ajd_optid")+'_text').val($(this).val());
                }
		if( $(this).is("select") && $(this).attr("ajd_type") == "stones" ) {
                        $(".select_"+$("option:selected", this).attr("ajd_optid")+" option[value='"+$("option:selected", this).attr("ajd_optvarid")+"']").attr("selected", "selected");
                        $('[name="options['+$("option:selected", this).attr("ajd_optid")+']"]').val($("option:selected", this).attr("ajd_optvarid"));
                }
		if($(this).attr("ajd_type") == "checkbox" ){
                $('input[name="options[' +$(this).attr("ajd_optid")+ '][]"]').val($(this).attr("ajd_optvarid"));
                $('input[name="options[' +$(this).attr("ajd_optid")+ '][]"]').prop("checked", true);
                }
	 });
	$inputs.each(function () {
		console.log($('#text-6686').val());
		$('#options_6686_text').val($('#text-6686').val());
		$('.input-text').prop("checked", true);
		$('#options_'+$(this).attr("ajd_optid")+'_text').val($(this).val());
		if( $(this).is("select") && $(this).attr("ajd_type") == "ddstones"  )  {
                         var e1 = document.getElementsByName('AJD_fields[1]');
                        var s1 = e1[0].options[e1[0].selectedIndex].value;
                        $('#selected_size_value').val(s1);
	        }
		if($(this).attr("ajd_type") == "checkbox" ){
                $('input[name="options[' +$(this).attr("ajd_optid")+ '][]"]').val($(this).attr("ajd_optvarid"));
		$('input[name="options[' +$(this).attr("ajd_optid")+ '][]"]').prop("checked", true);
                }
		console.log($(this).attr("ajd_type"));
		 if ($(this).attr("type") == "text2" || $('#text-6686').val() || $(this).attr("ajd_type") == "text2") {
                        $('#options_6686_text').val($('#text-6686').val());
			  //JQ_AJD('#options_8624_text').val(JQ_AJD('#text-8624').val());
                        console.log($(this).attr("ajd_optid") + 'test'+ $(this).val());
                        $('input[name="options[' +$(this).attr("ajd_optid")+ ']"]').val($(this).val());
			$('#options_'+$(this).attr("ajd_optid")+'_text').val($(this).val());
                        //JQ_AJD('input[name="options[' +JQ_AJD(this).attr("ajd_optid")+ ']"]').val(htmlEscape(JQ_AJD(this).val()));
                }
		//For Metal Attribute
		if( $(this).is("select") && $(this).attr("ajd_type") == "metal" && $("option:selected", this).attr("ajd_optid") && $("option:selected", this).attr("ajd_optvarid") ) {
			$('[name="super_attribute['+$("option:selected", this).attr("ajd_optid")+']"]').val($("option:selected", this).attr("ajd_optvarid"));
			//JQ_AJD('[name="super_attribute[253]"]').trigger( "change" );
			
		//For Birthstones Attribute
		}else if( $(this).is("select") && $(this).attr("ajd_type") == "ddstones" && $("option:selected", this).attr("ajd_optid") && $("option:selected", this).attr("ajd_optvarid") && $('[name="super_attribute['+$("option:selected", this).attr("ajd_optid")+']"]') ) {
			$('[name="super_attribute['+$("option:selected", this).attr("ajd_optid")+']"]').append($('<option>', {
				value: $("option:selected", this).attr("ajd_optvarid"),
				text: $("option:selected", this).text()
			}));
			
			$('[name="super_attribute['+$("option:selected", this).attr("ajd_optid")+']"]').val($("option:selected", this).attr("ajd_optvarid"));
                        var e1 = document.getElementsByName('AJD_fields[1]');
                        var s1 = e1[0].options[e1[0].selectedIndex].value;
                        $('#selected_size_value').val(s1);

		//For Size Attributie
		}else if( $(this).is("select") && $(this).attr("ajd_type") == "size" ) {
                        var e = document.getElementsByName('AJD_fields[1]');
                        //var attr = document.getElementsByName('AJD_fields[1]').getAttribute("ajd_type");
                        if (e[0].getAttribute("ajd_type") == "size" && e != null && e !== undefined) {
                         var s = e[0].options[e[0].selectedIndex].value;
   
                         //JQ_AJD('#selected_size_value').val(JQ_AJD("option:selected", this).attr("ajd_optvarid"));
                         $('#selected_size_value').val(s);
                        }
			var sizeval = $("option:selected", this).attr("ajd_optvarid");
			 //console.log(sizeval);
                        $('[name="super_attribute[229]"]').val(sizeval);
                        $('.super-attribute-select').val(sizeval).change();
			$("#attribute229 option[value='+ sizeval+']").attr("selected", "selected");
                        console.log($("#attribute229"));
			//JQ_AJD('#attribute229').append(JQ_AJD("<option selected='selected'></option>").attr("value", sizeval).text('testing')).change();

		//For Birthstones
		}else if( $(this).is("select") && $(this).attr("ajd_type") == "stones" ) {
			$(".select_"+$("option:selected", this).attr("ajd_optid")+" option[value='"+$("option:selected", this).attr("ajd_optvarid")+"']").attr("selected", "selected");
			$('[name="options['+ $("option:selected", this).attr("ajd_optid")+']"]').val($("option:selected", this).attr("ajd_optvarid"));

		//For Text Engraving
		} else if ($(this).attr("type") == "text2") {
			console.log('tttt');
			console.log($(this).attr("ajd_optid") + 'test'+ $(this).val());	
			$('input[name="options[' + $(this).attr("ajd_optid")+ ']"]').val($(this).val());
			//JQ_AJD('input[name="options[' +JQ_AJD(this).attr("ajd_optid")+ ']"]').val(htmlEscape(JQ_AJD(this).val()));

		
		// For ClipArt
		} else if ($(this).attr("type") == "hidden" && $(this).attr("ajd_type") == "comp_selector" ){
			
			if ( $(this).attr("clip_cat") ) {
				$('input[name="options[' +$(this).attr("ajd_optid")+ ']"]').val($(this).attr("clip_cat")+"-"+$(this).val());
			}else{
				$('input[name="options[' +$(this).attr("ajd_optid")+ ']"]').val($(this).val());
			}
			$('input[name="options[' + $(this).attr("ajd_optid")+ ']"]').removeClass('validate-special-data');
			
		}
	});

	$('#cart-image-holder').val(genimage);
	
	// Automatically select the Clipart input radio buttons for Left and Right Images
	var $inputs2 = $("#product_addtocart_form :input");
	
	$inputs2.each(function () {
	console.log('test');	
		if ($(this).attr("type") == "radio" && !$(this).is(":checked")) {
			$(this).attr('checked', 'checked');		
		}
		
	});

}

// submit data to cart
function func_post(genimage) {

	migrate_data(genimage); 
	/*if(document.getElementsByName('AJD_fields[1]')){
	var e1 = document.getElementsByName('AJD_fields[1]');
        var s1 = e1[0].options[e1[0].selectedIndex].value;
        JQ_AJD('#selected_size_value').val(s1);
	}*/
	$('#product-addtocart-button').trigger('click');
	$('#designerFormSubmit').text('Adding');
}

//submit data to wishlist
function wishlist_post(genimage) {

	migrate_data(genimage);
	
	JQ_AJD('.hiddenBtnWishlist').trigger('click');
	
}

function htmlEscape(str) {
    return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
};

function currencyFormat(num) {
    return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}

function change_select(){
	var $inputs = JQ_AJD("#" + AJD_from + " :input");
	
	$inputs.each(function () {
		
		if( JQ_AJD(this).is("select") && JQ_AJD(this).attr("ajd_type") == "metal" && JQ_AJD("option:selected", this).attr("ajd_optid") && JQ_AJD("option:selected", this).attr("ajd_optvarid") ) {
			JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').val(JQ_AJD("option:selected", this).attr("ajd_optvarid"));
			JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').change();
			//JQ_AJD('[name="super_attribute[253]"]').trigger( "change" );
		}
		if( JQ_AJD(this).is("select") && JQ_AJD(this).attr("ajd_type") == "ddstones" && JQ_AJD("option:selected", this).attr("ajd_optid") && JQ_AJD("option:selected", this).attr("ajd_optvarid") ) {
			

			var items = JQ_AJD("option", this).map(function() { return JQ_AJD(this).attr("ajd_optvarid"); });
			
		//	console.log(items);
			
			JQ_AJD.each(items, function (i, item) {
							console.log(item+'test');
				JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').append(JQ_AJD('<option>', { 
					value: item.value,
					text : item.text 
				}));
			});


			/*
			JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').append(JQ_AJD('<option>', {
				value: JQ_AJD("option:selected", this).attr("ajd_optvarid"),
				text: JQ_AJD("option:selected", this).text()
			}));
			*/
			
			
			JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').val(JQ_AJD("option:selected", this).attr("ajd_optvarid"));
			//JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').select();

		//For Size Attribute
		}
		
	});
}


function change_select_size(){
	var $inputs = $("#" + AJD_from + " :input");
	
	$inputs.each(function () {
		if( $(this).is("select") && $(this).attr("ajd_type") == "metal" && $("option:selected", this).attr("ajd_optid") && $("option:selected", this).attr("ajd_optvarid") ) {
			
			var $optid = $("option:selected", this).attr("ajd_optid");
			var $optvarid = $("option:selected", this).attr("ajd_optvarid");
			
			$('#attribute'+$optid).val($optvarid);
			// Dynamically change price according to selected metal
			//spConfig.reloadPrice();
			//JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').val(JQ_AJD("option:selected", this).attr("ajd_optvarid"));
			
		}
		
		if( $(this).is("select") && $(this).attr("ajd_type") == "size" && $("option:selected", this).attr("ajd_optid") && $("option:selected", this).attr("ajd_optvarid") ) {
			
			

			var items = $("option", this).map(function() { return $(this).attr("ajd_optvarid"); });
			
			
			$.each(items, function (i, item) {
				$('[name="super_attribute['+$("option:selected", this).attr("ajd_optid")+']"]').append($('<option>', { 
					value: item.value,
					text : item.text 
				}));
			});


			/*
			JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').append(JQ_AJD('<option>', {
				value: JQ_AJD("option:selected", this).attr("ajd_optvarid"),
				text: JQ_AJD("option:selected", this).text()
			}));
			*/
			
			
			$('[name="super_attribute['+$("option:selected", this).attr("ajd_optid")+']"]').val($("option:selected", this).attr("ajd_optvarid"));
			//JQ_AJD('[name="super_attribute['+JQ_AJD("option:selected", this).attr("ajd_optid")+']"]').select();

		//For Size Attribute
		}
		
	});
}


function size_update() {
	var $inputs = $("#" + AJD_from + " :input");
	
	var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	
	$inputs.each(function () {
		
		//For Metal Attribute
		if( $(this).is("select") && $(this).attr("ajd_type") == "metal" ) {
			
			//JQ_AJD(this).find(':selected').attr('ajd_optvarid');
			$metalid = $("option:selected", this).attr("ajd_optvarid");
		}
		//For Metal Attribute
		if( $(this).is("select") && $(this).attr("ajd_type") == "ddstones" ) {
			$birthstoneid = $("option:selected", this).attr("ajd_optvarid");
		}
		//For Size Attribute
		if( $(this).is("select") && $(this).attr("ajd_type") == "size" ) {
			
			$(this).children("option").show();
			$(this).prop('selectedIndex', 0);
			if($metalid ==undefined) {
				$(this).children("option[material_id!=" + $metalid + "]").hide();
			}
			if($metalid) {

				if(detectIE || is_safari) {  //for IE and Safari
					if($(this).find("option[material_id=" + $metalid + "]").parent().is('span')) {
						$(this).find("option[material_id=" + $metalid + "]").unwrap();
					}
					$(this).children("option[material_id!=" + $metalid + "]").wrap('<span>');
					$(this).find("option:first[material_id!=" + $metalid + "]").unwrap();
					
				} else {
					$(this).children("option[material_id!=" + $metalid + "]").hide();
					$(this).find("option:first[material_id!=" + $metalid + "]").show();
				}
				//console.log($birthstoneid);
				//if (typeof $birthstoneid !== 'undefined')
				//	JQ_AJD(this).children("option[birthstone_id!=" + $birthstoneid + "]").hide();
			}

		}		
	
	});

	change_select_size();
}


/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
       // Edge (IE 12+) => return version number
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}